export default "__VITE_ASSET__31dd09d6__"